<div class="headerSelect" *ngIf="showHeaderSelect">
    <span class="label">
        <ng-content select="[label]" class="labelSelect"></ng-content>
        <div class="required-label selectReq">&nbsp;{{isRequired ? '*' : ''}}</div> 
    </span>
    <div *ngIf="enableType && !disabled" class="icon-edit-type">
    
        <div ngbTooltip="{{'buttons.editSelect' | translate}}" tooltipClass="animation-tooltip" placement="top">
            <apc-basic-crud-modal *checkPermission="this.checkPermission"
        subtype="lov" [type]="enableType" [updateSelect]="true" [setSelect]="setSelect" [ngClass]="this.enableType"
            [hiddenTitle]="true" [fieldSelected]="this.value" (valueSelected)="upadateDefaultSelect($event)"
            [icon]="this.iconType" [iconEditeSel]="'assets/ico/edit-24px.svg'" [section]="this.sec" [subsection]="this.subSec" [pertinence]="this.pertinence">  
        </apc-basic-crud-modal>
        </div>
    
    </div>
</div>

<div class="container-select">

    <!-- backend validation message -->
    <span [ngClass]="value ? 'select-error-value form-error-icon' : 'select-error form-error-icon'"
        *ngIf="ngControl.errors?.length" [ngbTooltip]="ngControl.errors?.length ? errorTooltip : null" #t="ngbTooltip"
        triggers="manual" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" tooltipClass="apc-tooltip-top"
        placement="top" triggers="hover">
        <img src="assets/ico/error-solid.svg" alt="error">
    </span>
    <ng-template #errorTooltip>
        <span *ngFor="let error of ngControl.errors">
            {{error.message}} <br />
        </span>
    </ng-template>
    <!-- if view mode instead of select show text type su value can be copy pasted -->
    <input *ngIf='currentType == "text"' #input class="form-control select-text-placeholder" type="text"
        [value]="renderValue" [readonly]="true" (mouseenter)="handleSelectInputEdit()" (mouseleave)="setSelectType()" />

    <ng-select *ngIf="!isObject && currentType === 'select' && !disabled" #select [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}" [disabled]="disabled" (input)="onChange()" (change)="onChange()"
        (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (open)="emitSelect()"
        [placeholder]="placeholder" [loading]="loading" [items]="items" [bindLabel]="optionName"
        [attr.bindValue]="!isObject ? optionValue: null" [bindValue]="optionValue"
        (mouseenter)="handleSelectInputEdit()" (mouseleave)="setSelectType()" [ngClass]="'selectSize'">
        <ng-template ng-label-tmp let-item="item" *ngIf="valueDescription">
            <div class="ng-option-title font-weight-medium-bold" style="margin-bottom: -5px;">
                {{item[optionName]}}</div>
            <div *ngIf="optionDescription && optionDescription.length > 0">
                <div *ngFor="let optionDesc of optionDescription" style="font-size: 12px;"
                    class="ng-select-option-description">{{
                    'columnName.' + optionDesc | translate }}: <span class="font-weight-medium-bold">{{item[optionDesc]
                        ? item[optionDesc] : "N/A"}}</span></div>
            </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" *ngIf="!valueDescription">
            {{item[optionName]}}
        </ng-template>
        <ng-template ng-option-tmp let-option="item">
            <div class="ng-option-title"
                [ngClass]="optionDescription && optionDescription.length > 0 ? 'font-weight-medium-bold' : ''">
                {{option[optionName]}}</div>
            <div *ngIf="optionDescription && optionDescription.length > 0">
                <div *ngFor="let optionDesc of optionDescription" class="ng-select-option-description">{{
                    'columnName.' + optionDesc | translate }}: <span
                        class="font-weight-medium-bold">{{option[optionDesc]}}</span>
                        </div>
            </div>
        </ng-template>
    </ng-select>

    <span class="disabledInputSpan" *ngIf="!isObject && currentType === 'select' && disabled && value">{{value.name}}</span>
    <span class="disabledInputSpan" *ngIf="!isObject && currentType === 'select' && disabled && !value">&nbsp;</span>
    
    <ng-select  [ngClass]="disabled?'selectSizeIcon':'selectSize'" *ngIf="isObject && currentType === 'select' && !disabled" #select [(ngModel)]="value"
        [class.autogeneratedSelect]="autogenerated" [ngModelOptions]="{standalone: true}" [disabled]="disabled"
        (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()"
        (mouseout)="t?.close()" (open)="emitSelect()" [placeholder]="placeholder" [loading]="loading" [items]="items"
        [bindLabel]="optionName" (mouseenter)="handleSelectInputEdit()" (mouseleave)="setSelectType()"
        [searchFn]="customSearchFn" (clear)="clearAppendedExtraSearch(true)">
        <ng-template ng-option-tmp let-option="item">
            <div class="ng-option-title" [ngClass]="selectClass(option)">
                {{option[optionName]}}
                <div *ngIf="option.companyUID">
                    <span style="font-weight:normal" class="ng-select-option-description">UID: <span
                            class="font-weight-medium-bold">{{option.companyUID}}
                        </span>
                    </span>
                </div>
            </div>
            <div *ngIf="optionDescription && optionDescription.length > 0">
                <div *ngFor="let optionDesc of optionDescription" class="ng-select-option-description">
                    <span *ngIf="option[optionDesc]">{{ 'columnName.' + optionDesc | translate }}: <span
                            class="font-weight-medium-bold">{{option[optionDesc]}}
                        </span>
                    </span>
                </div>
            </div>
            
            
        </ng-template>
        
    </ng-select>

    <span [ngClass]="this.value && disabled && this.managerSelect?'disabledInputSpanIcon':'disabledInputSpan'" *ngIf="isObject && currentType === 'select' && disabled && value">{{value.name}}</span>
    <span [ngClass]="this.value && disabled && this.managerSelect?'disabledInputSpanIcon':'disabledInputSpan'" *ngIf="isObject && currentType === 'select' && disabled && !value">&nbsp;</span>
    
    <a *ngIf="this.value && disabled && this.managerSelect" [routerLink]="this.routerLink" target="_blank">
        <img class="action-icon redirectManager" src="assets/ico/arrow-up-right-from-square-solid.svg"  alt="action icon"> 
    </a>
</div>